import React from 'react';
import CrudTable from '../../components/admin/CrudTable';

export default function ManageTimeline() {
  return (
    <CrudTable
      entity="timeline"
      title="Karyera / Timeline"
      defaults={{ period: '', title: '', bullets: [], order: 0 }}
      fields={[
        { key: 'period', label: 'Dövr (məs: 05.05.2025 - davam edir)', type: 'text' },
        { key: 'title', label: 'Vəzifə / Başlıq', type: 'text' },
        { key: 'bullets', label: 'Alt-punktlar', type: 'list' },
        { key: 'order', label: 'Sıra', type: 'number' },
      ]}
      listColumns={[
        { key: 'period', label: 'Dövr' },
        { key: 'title', label: 'Vəzifə' },
        { key: 'order', label: 'Sıra' },
      ]}
    />
  );
}
